declare var window: any;

export class DynamicEnvironment {
  public production: boolean;
  public environment_mode: string;
  public domain_config_gw_api: string;

  public get language() {
    return window.config.language;
  }

  public get netmera_key() {
    return window.config.netmera_key;
  }

  public get enterprise_domain() {
    return window.config.enterprise_domain;
  }

  public get individual_domain() {
    return window.config.individual_domain;
  }

  public get gateway_api() {
    return window.config.gateway_api;
  }

  public get origin_url() {
    return window.config.origin_url;
  }

  public get socket_url() {
    return window.config.socket_url;
  }

  public get email() {
    return window.config.email;
  }

  public get brand_header() {
    return window.config.brand_header;
  }

  public get logo() {
    return window.config.logo;
  }

  public get background_image() {
    return window.config.background_image;
  }

  public get sso_url() {
    return window.config.sso_url;
  }

  public get admin_api_url() {
    return window.config.admin_api_url;
  }
}
